/**
 * Opções dos campos que só o PRODUTO tem (`Catalog.category = 'PRODUCT'`).
 *
 * Fora do formulário porque ele já é grande e porque a listagem e a importação por
 * planilha precisam dos mesmos rótulos — duplicar a tabela faria "Caixa" virar "CX"
 * numa tela e não na outra.
 */

export const PRODUCT_UNITS: { value: string; label: string }[] = [
    { value: 'UNIT', label: 'Unidade' },
    { value: 'KG', label: 'Quilograma (kg)' },
    { value: 'GRAM', label: 'Grama (g)' },
    { value: 'LITER', label: 'Litro (L)' },
    { value: 'ML', label: 'Mililitro (ml)' },
    { value: 'METER', label: 'Metro (m)' },
    { value: 'CM', label: 'Centímetro (cm)' },
    { value: 'HOUR', label: 'Hora' },
    { value: 'SESSION', label: 'Sessão' },
    { value: 'PACK', label: 'Pacote' },
    { value: 'BOX', label: 'Caixa' },
    { value: 'PAIR', label: 'Par' },
    { value: 'DOZEN', label: 'Dúzia' },
]

/** Origem da mercadoria — campo obrigatório da NF-e (tabela da SEFAZ). */
export const PRODUCT_ORIGINS: { value: string; label: string }[] = [
    { value: 'NATIONAL', label: 'Nacional' },
    { value: 'IMPORTED', label: 'Estrangeira — importação direta' },
    {
        value: 'IMPORTED_NATIONAL_CONTENT',
        label: 'Estrangeira — adquirida no mercado interno',
    },
    {
        value: 'NATIONAL_IMPORTED_CONTENT',
        label: 'Nacional com conteúdo de importação',
    },
]

/**
 * Peso e medidas, na ordem em que o operador lê a etiqueta. Alimentam o cálculo de
 * frete (Melhor Envio) — sem eles a cotação usa um valor padrão e sai errada.
 */
export const PRODUCT_DIMENSIONS: { field: string; label: string }[] = [
    { field: 'weight', label: 'Peso (kg)' },
    { field: 'width', label: 'Largura (cm)' },
    { field: 'height', label: 'Altura (cm)' },
    { field: 'depth', label: 'Profundidade (cm)' },
]
